import {style} from 'typestyle'
import * as csstips from 'csstips'

export const empty = style({
    width: '100%',
    height: 'calc(100vh - 44px)',
    position: 'relative',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center
})

export const wrap = style({
    textAlign: 'center'
})

export const pic = style({
    width: 150,
    height: 150
})

export const tip = style({
    fontSize: '14px',
    color: '#999',
    textAlign: 'center',
    lineHeight: '20px',
    marginTop: 10,
    marginBottom: 30
})

export const button = style({
    background: '#ff5a31',
    borderRadius: '22px',
    outline: 'none',
    border: 'none',
    fontSize: '18px',
    color: '#fff',
    textAlign: 'center',
    lineHeight: '18px',
    padding: '13px 40px',
    cursor: 'pointer'
})



// WEBPACK FOOTER //
// ./src/views/SearchResult/SearchResult.style.ts